export default function MySQL_SESSION_USER() {
  return (
    <div>
      <h2>MySQL_SESSION_USER</h2>    </div>
  );
}